var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gradient = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../../elements/Basic");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/ColorUtility.js";

var Gradient = function Gradient(_ref) {
  var proportions = _ref.proportions,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["proportions"]);
  return _react.default.createElement(_Basic.View, (0, _extends2.default)({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }), proportions.map(function (proportion) {
    return _react.default.createElement(_Basic.View, {
      key: "gradient_" + proportion.percentage + "_" + proportion.bg,
      height: proportion.percentage,
      bg: proportion.bg,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 7,
        columnNumber: 13
      }
    });
  }));
};

exports.Gradient = Gradient;
Gradient.defaultProps = {
  height: '100%',
  width: '100%',
  position: 'absolute',
  proportions: []
};